import PropTypes from 'prop-types';
import { DateTime } from 'luxon';
import React from 'react';
import { returnESTDayNumberOnly } from '../../../../../../stores/websocketStore/utils/mungingUtils/timeFormatting/returnESTDayNumberOnly';
import { fontSizes } from '../../../../../atomic/text/Text';
const lowAlphaWhite = 'rgba(255, 255, 255, 0.3)';
export const ChartDayLines = ({
  timeUnit,
  processedCandles,
  size,
  bottomPadding,
}) => {
  if (!processedCandles) return null;
  if (timeUnit !== 'MINUTES') return null;
  const candlesLength = processedCandles.length;
  const lineArray = processedCandles.reduce((acc, candle, index) => {
    if (index === candlesLength - 1) {
      return acc;
    } else {
      const nextCandle = processedCandles[index + 1];
      const thisCandleTimeStamp = candle.timeStamp;
      const nextCandleTimeStamp = nextCandle.timeStamp;
      const thisDay = returnESTDayNumberOnly(thisCandleTimeStamp);
      const nextCandleDay = returnESTDayNumberOnly(nextCandleTimeStamp);
      if (thisDay !== nextCandleDay) {
        const spaceBetweenCandles = nextCandle.lineXPos - candle.lineXPos;
        const dayLineXPos = candle.lineXPos + spaceBetweenCandles / 2;
        const lineDateString = new DateTime.fromMillis(nextCandleTimeStamp)
          .setZone('America/New_York')
          .toFormat('M/d');
        const infoObj = {
          dayLineXPos,
          lineDateString,
        };
        return [...acc, infoObj];
      } else return acc;
    }
  }, []);
  return (
    <g strokeWidth={1} stroke={lowAlphaWhite}>
      {lineArray.map(({ dayLineXPos, lineDateString }) => (
        <g key={dayLineXPos}>
          <line
            strokeDasharray="5,5"
            x1={dayLineXPos}
            x2={dayLineXPos}
            y1={0}
            y2={size + bottomPadding}
          />
          <text style={{ fontSize: fontSizes.body3, fontWeight: 400 }} x={dayLineXPos + 2} y={size}>
            {lineDateString}
          </text>
        </g>
      ))}
    </g>
  );
};

ChartDayLines.propTypes = {
  bottomPadding: PropTypes.number,
  processedCandles: PropTypes.array,
  size: PropTypes.number,
  timeUnit: PropTypes.string,
};
